import { IUser, Maybe } from 'src/types/graphql'
import { RedirectUrls } from 'src/types/types'

const LOGIN = `${RedirectUrls.Login}?redirectL=${encodeURIComponent(
  RedirectUrls.SubmitLocation
)}`
const CONFIRMATION = `${RedirectUrls.UserConfirmation}?redirectU=${encodeURIComponent(
  RedirectUrls.SubmitLocation
)}`

export function getSubmitLocation(currentUser: Maybe<IUser>): string {
  if (!currentUser) return LOGIN
  const needsVerification =
    !currentUser.isVerified && !currentUser.requestedVerification
  const href = needsVerification ? CONFIRMATION : RedirectUrls.SubmitLocation
  return href
}
